import { useState, useEffect } from "react";
import { CaretDown } from "@phosphor-icons/react";
import { useInView } from "@/hooks/useInView";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function FAQSection() {
  const [faqs, setFaqs] = useState([]);
  const [openId, setOpenId] = useState(null);
  const [ref, inView] = useInView();

  useEffect(() => {
    axios.get(`${API}/faq`).then(({ data }) => setFaqs(data)).catch(() => {});
  }, []);

  if (!faqs.length) return null;

  return (
    <section id="faq" data-testid="faq-section" className="bg-[#111111] py-16 sm:py-20" ref={ref}>
      <div className="max-w-3xl mx-auto px-6 lg:px-8">
        <p className={`text-xs tracking-[0.2em] uppercase font-bold text-[#D4AF37] font-body mb-4 reveal ${inView ? 'visible' : ''}`}>Frequently Asked</p>
        <h2 className={`font-heading text-3xl sm:text-4xl font-bold tracking-tight text-[#F2EFE9] mb-12 reveal ${inView ? 'visible' : ''} stagger-1`}>
          Got questions?
        </h2>
        <div className="space-y-2">
          {faqs.map((f, i) => (
            <div
              key={f.id}
              data-testid={`faq-item-${f.id}`}
              className={`glass-card border border-white/10 rounded-lg overflow-hidden hover:border-white/20 transition-all reveal ${inView ? 'visible' : ''} stagger-${Math.min(i + 1, 6)}`}
            >
              <button
                data-testid={`faq-toggle-${f.id}`}
                onClick={() => setOpenId(openId === f.id ? null : f.id)}
                className="w-full flex items-center justify-between p-5 text-left hover:bg-white/5 transition-colors"
              >
                <span className="font-heading text-sm font-semibold text-[#F2EFE9] pr-4">{f.question}</span>
                <CaretDown
                  size={18}
                  className={`text-[#D4AF37] flex-shrink-0 transition-transform duration-300 ${openId === f.id ? 'rotate-180' : ''}`}
                />
              </button>
              <div
                className={`grid transition-all duration-300 ease-in-out ${openId === f.id ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`}
              >
                <div className="overflow-hidden">
                  <div className="px-5 pb-5">
                    <p className="text-sm text-[#8C8C8C] font-body leading-relaxed">{f.answer}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
